import BannerBlock from './BannerBlock'

export default BannerBlock
